/**
 * @author liqiuqi
 * @date 2022 2022/4/24 13:59
 */
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 获取静态初始化数据
export function getInitialStaticDataFromOss() {
  return omniAxios({
    url: config.ossStaticDataPath,
    method: "get",
    params: {},
    isFromOss: true,
  });
}

// 获取用户信息
export function restUCompanyGetCompanyInfo() {
  return omniAxios({
    url: config.restUCompanyGetCompanyInfoPath,
    method: "get",
    params: {},
  });
}

// 获取灰度功能
export function restUGrayReleaseFeatures() {
  return omniAxios({
    url: config.restUGrayReleaseFeaturesPath,
    method: "get",
    params: {},
  });
}

// 获取是否显示新手引导
export function restAccountUpgradeUserGuide() {
  return omniAxios({
    url: config.restAccountUpgradeUserGuidePath,
    method: "get",
    params: {},
  });
}

// 登出
export function restLogout() {
  return omniAxios({
    url: config.restLogoutPath,
    method: "get",
    params: {},
  });
}

// 公共埋点
export function userBehaviorInsertRecordWebsite(params) {
  return omniAxios({
    url: config.userBehaviorInsertRecordWebsitePath,
    method: "post",
    params,
    isTracker: true, // 埋点类接口
    withCredentials: false,
  });
}

export function restApplicationMyApplicationControllerGetMyApplication() {
  return omniAxios({
    url: config.restApplicationMyApplicationControllerGetMyApplicationPath,
    method: "get",
    params: {},
  });
}

// 是否优秀供应商
export function restAccountSupplierStarSearch() {
  return omniAxios({
    url: config.restAccountSupplierStarSearchPath,
    method: "get",
    params: {},
  });
}

// 用户登录
export function restUApiUserNewWebLogin({ password, username, source }) {
  return omniAxios({
    url: config.restUApiUserNewWebLoginPath,
    method: "get",
    params: {
      psw: password,
      username,
      source: source || "",
      remLogin: 1,
    },
    withCredentials: false,
    useDevServerProxy: true, //登录是老接口，后台没有处理本地跨域问题，怕存在风险
  });
}

// 用户登录后获取登录时间
export function restULoginControllerUserLoginTime() {
  return omniAxios({
    url: config.restULoginControllerUserLoginTimePath,
    method: "get",
    useDevServerProxy: true, //老接口，后台没有处理本地跨域问题，怕存在风险
  });
}

//登录获取手机验证码
export function restUApiMemberLoginSendSms(params) {
  return omniAxios({
    url: config.restUApiMemberLoginSendSmsPath,
    method: "post",
    params,
    isFormData: true,
    withCredentials: false,
  });
}

//获取可以手机号登录的用户类型
export function restUApiMemberLoginGetUsers(params) {
  return omniAxios({
    url: config.restUApiMemberLoginGetUsersPath,
    method: "post",
    params,
    isFormData: true,
    withCredentials: false,
  });
}

//登录
export function restUApUserPhoneLogin({ password, username }) {
  return omniAxios({
    url: config.restUApUserPhoneLoginPath,
    method: "get",
    params: { password, username },
    withCredentials: false,
    useDevServerProxy: true,
    header: { Authorization: `Basic ${password}` },
  });
}

// 快捷注册/登录接口
export function restUApiUserCodeLogin(params) {
  return omniAxios({
    url: config.restUApiUserCodeLoginPath,
    method: "get",
    params,
    withCredentials: false,
  });
}

//获取ip地址
export function apiIpify(params) {
  return omniAxios({
    url: "https://api.ipify.org/?format=" + params.format,
    method: "get",
    timeout: 500,
  });
}
//获取弹窗浏览记录, type: 8找商机-标讯,9找商机-拟在建项目,10找商机-审批项目,13订阅信息-招标采购tab,14订阅信息-拟在建项目tab,15订阅信息-审批项目tab，16：企业监控企业动态
export function restAccountPopupGetLog({ type }) {
  return omniAxios({
    url: config.restAccountPopupGetLogPath,
    method: "get",
    params: { type },
  });
}
// 完善用户信息
export function restUPersonalMembersInfoUpdate({ dwmc, linkName, zhiwu, source }) {
  return omniAxios({
    url: config.restUPersonalMembersInfoUpdatePath,
    isFormData: true,
    method: "post",
    params: {
      dwmc,
      linkName,
      zhiwu,
      source,
    },
  });
}

// 获取小程序二维码接口
export function restULoginQrCodeUnionIdLogin() {
  return omniAxios({
    url: config.restULoginQrCodeUnionIdLoginPath,
    method: "get",
  });
}

// 小程序二维码轮询接口
export function restULoginQrCodeGetLoginQrCodeState(params) {
  return omniAxios({
    url: config.restULoginQrCodeGetLoginQrCodeStatePath,
    method: "get",
    params,
  });
}
